  <template>
      <b-table id="registrations" :fields="fields" :items="rows" @row-clicked="showDetails" responsive>
        <!-- School name -->
        <template v-slot:cell(school)="row">
          <router-link :to="{name: 'admin.registration', params:{id: row.item.id}}" :class="row.item.deletedAt ? 'red' : ''">
            {{ row.value.name }}
          </router-link>
        </template>

        <!-- City -->
        <template v-slot:cell(city)="row">
          {{ row.item.school.city }}<span v-if="row.item.school.city !== row.item.school.state.name" v-b-tooltip.hover :title="row.item.school.state.name">, {{ row.item.school.state.code }}</span>
        </template>

        <template v-slot:cell(registrations)="row">
          <span :class="row.item.deletedAt ? 'red' : ''">{{ row.value.count }}</span>
        </template>

        <template v-slot:cell(payed)="row">
          {{ Math.floor(row.item.payment.payed.float / price) }}
        </template>

        <template v-slot:cell(payment)="row">
          <div v-b-tooltip.hover.right :title="'Summe: ' + row.value.total.short + ' | Bezahlt: ' + row.value.payed.short">
            <span v-if="row.value.saldo.float < 0" @click.stop="$emit('payment', row.item.id)" style="color: red">
              {{ row.value.saldo.short }}
            </span>

            <span v-else @click.stop="$emit('payment', row.item.id)">
              {{ row.value.saldo.short }}
            </span>
          </div>
        </template>

        <template v-slot:row-details="row" @clicked="row.toggleDetails">
          <row-details :row="row"
            v-on:delete="payload => $emit('delete', payload)"
            v-on:edit="payload=> $emit('edit', payload)"
          />
        </template>
      </b-table>
</template>

<script>
import RowDetails from './RowDetails'

export default {
  name: 'RegistrationsTable',
  props: ['rows', 'price'],
  components: {RowDetails},
  data: function () {
    return {
      fields: [
        {key: 'school', label: 'Schule'},
        {key: 'city', label: 'Stadt'},
        {key: 'registrations', label: 'Anmeldungen', class: 'text-center'},
        {key: 'payed', label: 'Bezahlt', class: 'text-center'},
        {key: 'payment', label: 'Saldo', class: 'text-right clickable'}
      ]
    }
  },

  methods: {
    showDetails: function (item) {
      this.rows.forEach((row) => {
        if (row.id !== item.id) {
          row._showDetails = false
        }
      })

      item._showDetails = !item._showDetails
    }
  },

  filters: {
    nl2br: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.split('\n').join('<br/>')
    }
  }
}
</script>

<style scoped>
table#registrations ul {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/admin/registration/RegistrationsTable.vue